<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
import { config } from '../config'

export default {
  name: 'App',
  created() {
    if (config.mode === 'stage') {
      document.title = 'GDQ Administration STAGE'
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
